
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ExchangeTaxGrid extends Serenity.EntityGrid<ExchangeTaxRow, any> {
        protected getColumnsKey() { return 'Retail.ExchangeTax'; }
        protected getIdProperty() { return ExchangeTaxRow.idProperty; }
        protected getInsertPermission() { return ExchangeTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return ExchangeTaxRow.localTextPrefix; }
        protected getService() { return ExchangeTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}